import { useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import RecipeListPage from './pages/RecipeListPage';
import RecipeDetailPage from './pages/RecipeDetailPage';
import RecipeEditPage from './pages/RecipeEditPage';
import SendToBringPage from './pages/SendToBringPage';
import CookModePage from './pages/CookModePage';
import MenuListPage from './pages/MenuListPage';
import MenuDetailPage from './pages/MenuDetailPage';
import MenuSummaryPage from './pages/MenuSummaryPage';
import { api } from './api/client';

type AuthState = 'unknown' | 'authenticated' | 'anonymous';

export default function App() {
  const [auth, setAuth] = useState<AuthState>('unknown');
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    api
      .get('/api/v1/auth/me')
      .then(() => !cancelled && setAuth('authenticated'))
      .catch(() => !cancelled && setAuth('anonymous'));
    return () => {
      cancelled = true;
    };
  }, []);

  if (auth === 'unknown') {
    return (
      <div className="flex min-h-[100svh] items-center justify-center">
        <div className="text-muted animate-riseIn">caricamento…</div>
      </div>
    );
  }

  if (auth === 'anonymous' && location.pathname !== '/login') {
    return <Navigate to="/login" replace />;
  }

  return (
    <Routes>
      <Route
        path="/login"
        element={
          auth === 'authenticated' ? (
            <Navigate to="/" replace />
          ) : (
            <LoginPage onLogin={() => setAuth('authenticated')} />
          )
        }
      />
      <Route path="/" element={<RecipeListPage />} />
      <Route path="/recipe/new" element={<RecipeEditPage />} />
      <Route path="/recipe/:id" element={<RecipeDetailPage />} />
      <Route path="/recipe/:id/edit" element={<RecipeEditPage />} />
      <Route path="/recipe/:id/send" element={<SendToBringPage />} />
      <Route path="/recipe/:id/cook" element={<CookModePage />} />
      <Route path="/menus" element={<MenuListPage />} />
      <Route path="/menu/:id" element={<MenuDetailPage />} />
      <Route path="/menu/:id/summary" element={<MenuSummaryPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
